/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'

icon.register({
  'equiptype': {
    width: 64,
    height: 64,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M114.062 857.486V114.062a56.889 56.889 0 0157.174-57.173h457.5a56.889 56.889 0 0157.173 57.173v257.309h171.577a56.889 56.889 0 0157.174 57.173v428.885h28.444a28.558 28.558 0 110 57.174H85.447a28.558 28.558 0 010-57.174zm57.174 0h457.5V114.062h-457.5zm686.25 0V428.715H685.91V857.6zM314.254 257.024h171.577a28.558 28.558 0 110 57.173H314.254a28.558 28.558 0 110-57.173zm0 200.135h171.577a28.558 28.558 0 110 57.173H314.254a28.558 28.558 0 110-57.173zm0 200.135h171.577a28.558 28.558 0 110 57.174H314.254a28.558 28.558 0 010-57.174zm0 0" _fill="#484848"/>'
  }
})
